var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { get } from "lodash";
import { Select, Radio } from "@irati/ui/src/FormItem";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Close from "@irati/ui/src/Close";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import OccasionsSelect from "@irati-web/fields/occasions/OccasionsSelect";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import { PaymentType } from "../enums";
import RewardSelect from "./Picker";
import { customRewardThumbnail } from "./Search";
import { buildProductOptions, getTotal } from "../utils";
import { RewardThumbnail, TitleContainer, InputWrapper, H4 } from "./styled";
var cardPaymentOption = { label: React.createElement(FormattedMessage, { id: "reward.checkout.paymentMethod.card.label" }), value: PaymentType.NEW_CARD };
var walletPaymentOption = { label: React.createElement(FormattedMessage, { id: "reward.checkout.paymentMethod.wallet.label" }), value: PaymentType.REWARD_WALLET };
var Checkout = /** @class */ (function (_super) {
    __extends(Checkout, _super);
    function Checkout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            paymentOptions: [],
            rewardOptions: [],
            selectedOption: null,
            clickDenominationEventTracked: false
        };
        _this.handleSelectClick = function () {
            if (_this.props.isCredit && !_this.state.clickDenominationEventTracked) {
                _this.setState({ clickDenominationEventTracked: true });
                rewardWalletTracking.clickDenominationDropdownCheckout();
            }
        };
        _this.handleSelectOnChange = function (selectedOption) {
            var _a = _this.props, reward = _a.reward, setProduct = _a.setProduct, isCredit = _a.isCredit;
            var products = get(reward, "products.results");
            var selectedProduct = products.find(function (product) { return product.uuid === selectedOption; });
            if (isCredit) {
                rewardWalletTracking.selectDenominationCheckout();
            }
            setProduct(selectedProduct);
        };
        _this.handleClose = function () {
            var _a = _this.props, isCredit = _a.isCredit, setReward = _a.setReward;
            if (isCredit) {
                rewardWalletTracking.clearReward();
            }
            setReward();
        };
        return _this;
    }
    Checkout.prototype.componentDidMount = function () {
        var _a = this.props, reward = _a.reward, product = _a.product, recipientsCount = _a.recipientsCount, intl = _a.intl, rewardWallet = _a.rewardWallet;
        var availableWalletBalance = get(rewardWallet, "availableBalance");
        if (reward && product) {
            var selectedOption = product.uuid;
            var paymentOptions = getPaymentOptions(reward, product, availableWalletBalance, recipientsCount);
            var rewardOptions = buildProductOptions(reward, intl);
            this.setState({
                paymentOptions: paymentOptions,
                selectedOption: selectedOption,
                rewardOptions: rewardOptions
            });
        }
    };
    Checkout.getDerivedStateFromProps = function (nextProps) {
        var reward = nextProps.reward, product = nextProps.product, recipientsCount = nextProps.recipientsCount, intl = nextProps.intl, paymentMethod = nextProps.paymentMethod, rewardWallet = nextProps.rewardWallet;
        var availableWalletBalance = get(rewardWallet, "availableBalance");
        if (reward) {
            var selectedOption = get(product, "uuid");
            var paymentOptions = getPaymentOptions(reward, product, availableWalletBalance, recipientsCount);
            var rewardOptions = buildProductOptions(reward, intl);
            if (reward.isCredit && paymentMethod !== PaymentType.REWARD_WALLET) {
                nextProps.setPaymentMethod(PaymentType.REWARD_WALLET);
            }
            return {
                paymentOptions: paymentOptions,
                selectedOption: selectedOption,
                rewardOptions: rewardOptions
            };
        }
        return {
            paymentOptions: [],
            selectedOption: null
        };
    };
    Checkout.prototype.render = function () {
        var _a = this.props, reward = _a.reward, product = _a.product, setReward = _a.setReward, setPaymentMethod = _a.setPaymentMethod, paymentMethod = _a.paymentMethod, customRewardName = _a.customRewardName, recipientsCount = _a.recipientsCount, rewardWallet = _a.rewardWallet, addRewardEntity = _a.addRewardEntity, setOccasion = _a.setOccasion, selectedOccasion = _a.selectedOccasion;
        var _b = this.state, selectedOption = _b.selectedOption, paymentOptions = _b.paymentOptions, rewardOptions = _b.rewardOptions;
        var costTotal = getTotal(product, recipientsCount);
        var availableWalletBalance = get(rewardWallet, "availableBalance") || 0;
        var showWalletDetails = product && paymentMethod === PaymentType.REWARD_WALLET && costTotal <= availableWalletBalance;
        return (React.createElement(React.Fragment, null,
            addRewardEntity && (React.createElement(InputWrapper, null,
                React.createElement(OccasionsSelect, { selectedOption: selectedOccasion, onChange: setOccasion }))),
            !reward && !customRewardName && (React.createElement(InputWrapper, null,
                React.createElement(RewardSelect, { onChange: setReward }))),
            reward && (React.createElement(InputWrapper, null,
                React.createElement(Col, { xs: 2 },
                    React.createElement(RewardThumbnail, { src: reward.thumbnailImage, alt: reward.header })),
                React.createElement(Col, { xs: 10 },
                    React.createElement(TitleContainer, null,
                        React.createElement("h5", null, reward.header),
                        React.createElement(Close, { onClick: this.handleClose })),
                    React.createElement("div", { onClick: this.handleSelectClick },
                        React.createElement(Select, { label: "reward.detail.select.label", name: "product-id", options: rewardOptions, onChange: this.handleSelectOnChange, isClearable: false, value: selectedOption }))))),
            customRewardName && (React.createElement(Row, null,
                React.createElement(Col, { xs: 2 },
                    React.createElement(RewardThumbnail, { src: customRewardThumbnail, alt: customRewardName })),
                React.createElement(Col, { xs: 10 },
                    React.createElement("h4", null,
                        React.createElement(FormattedMessage, { id: "reward.fields.reward.customReward.title", values: { custom: customRewardName } })),
                    React.createElement("p", null,
                        React.createElement(FormattedMessage, { id: "reward.fields.reward.customReward.Hint" }))))),
            !customRewardName && product && (React.createElement(React.Fragment, null,
                React.createElement(Row, null,
                    React.createElement(Col, { md: 12 },
                        React.createElement(H4, null,
                            React.createElement(FormattedMessage, { id: "reward.checkout.paymentMethod.label" }))),
                    React.createElement(Col, { md: 12 }, !!paymentOptions.length && (React.createElement(Radio, { name: "Payment Method", value: paymentMethod, options: paymentOptions, onChange: function (paymentType) { return setPaymentMethod(paymentType); } })))),
                showWalletDetails && (React.createElement(Row, null,
                    React.createElement(Col, { md: 4 },
                        React.createElement(Table, null,
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement(FormattedMessage, { id: "reward.checkout.walletBalance" })),
                                React.createElement("td", null, formatCurrency({ value: availableWalletBalance, isCents: false }))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement(FormattedMessage, { id: "reward.checkout.totalToPay" })),
                                React.createElement("td", null, formatCurrency({ value: costTotal, isCents: false }))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement(FormattedMessage, { id: "reward.checkout.newBalance" })),
                                React.createElement("td", null, formatCurrency({ value: availableWalletBalance - costTotal, isCents: false })))))))))));
    };
    return Checkout;
}(Component));
export default injectIntl(Checkout);
var getPaymentOptions = function (reward, product, availableWalletBalance, recipientsCount) {
    if (availableWalletBalance === void 0) { availableWalletBalance = 0; }
    if (!product) {
        return [];
    }
    var costTotal = product.price * recipientsCount;
    var paymentOptions = [];
    if (!reward.isCredit) {
        paymentOptions.push(cardPaymentOption);
    }
    if (costTotal <= availableWalletBalance) {
        paymentOptions.push(walletPaymentOption);
    }
    return paymentOptions;
};
